 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		32: 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		32: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"styles","3":"component---src-pages-404-js","4":"component---src-pages-index-js","5":"component---src-pages-litjen-adventskalender-index-js","6":"component---src-pages-litjen-adventskalender-luke-1-8-lc-ou-js","7":"component---src-pages-litjen-adventskalender-luke-10-nno-gy-js","8":"component---src-pages-litjen-adventskalender-luke-11-w-cue-k-js","9":"component---src-pages-litjen-adventskalender-luke-12-xw-uhc-js","10":"component---src-pages-litjen-adventskalender-luke-13-i-nns-6-js","11":"component---src-pages-litjen-adventskalender-luke-14-qx-nd-9-js","12":"component---src-pages-litjen-adventskalender-luke-15-gq-auh-js","13":"component---src-pages-litjen-adventskalender-luke-16-4-f-u-1-f-js","14":"component---src-pages-litjen-adventskalender-luke-17-nwo-7-a-js","15":"component---src-pages-litjen-adventskalender-luke-18-3-nxo-3-js","16":"component---src-pages-litjen-adventskalender-luke-19-m-rsx-a-js","17":"component---src-pages-litjen-adventskalender-luke-2-lff-lm-js","18":"component---src-pages-litjen-adventskalender-luke-20-g-gxj-c-js","19":"component---src-pages-litjen-adventskalender-luke-21-r-7-v-nd-js","20":"component---src-pages-litjen-adventskalender-luke-22-f-xjkx-js","21":"component---src-pages-litjen-adventskalender-luke-23-xm-2-bu-js","22":"component---src-pages-litjen-adventskalender-luke-24-5-mc-rz-js","23":"component---src-pages-litjen-adventskalender-luke-3-s-5-tj-m-js","24":"component---src-pages-litjen-adventskalender-luke-4-m-xvs-o-js","25":"component---src-pages-litjen-adventskalender-luke-5-k-5-w-xc-js","26":"component---src-pages-litjen-adventskalender-luke-6-jm-9-zz-js","27":"component---src-pages-litjen-adventskalender-luke-7-q-8-qv-g-js","28":"component---src-pages-litjen-adventskalender-luke-8-ne-x-at-js","29":"component---src-pages-litjen-adventskalender-luke-9-l-bq-de-js","30":"component---src-pages-velkommen-js","31":"pages-manifest"}[chunkId]||chunkId) + "-" + {"0":"81109bc48e2192c563c4","1":"e49cd61c95cc1115588c","3":"657951124fd5e28e46ed","4":"a7b972bfa0f1e91e66b4","5":"e57712636b49521e6972","6":"3838e81d44acc133a6dd","7":"84c9753ad49a6b2c85ca","8":"793b226e58d29081d12f","9":"61c2b45f7972f4512bca","10":"c1620f67b8c25c2112de","11":"a8ee52487cbd715c2cb2","12":"a2d59a1944696491bf64","13":"f10777f5eb3809c82941","14":"548099adccca1fd7ea96","15":"7b812347f4c138adfd04","16":"a51c8448aaa865d7beb3","17":"62d6ee4ffa2021db0590","18":"4e0fe1fbfbb046b4ae54","19":"6cf417b50b926a34daaf","20":"a3b8506addec0b549bb8","21":"b8071c1af5d4f5ceb5c5","22":"684bb276177be9391922","23":"47e5c22cfa96728a2547","24":"e615b90e7fc91a8a6006","25":"ce6b8525c1a2b72c5e80","26":"fbb491f133c356d418a9","27":"a35a81a8d7c011bbd7cf","28":"deedbb997ec1c976b282","29":"68317def8a177641193f","30":"5154c20d703bf30f8aad","31":"fd5189896ad1d2960e33"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"0":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "" + ({"0":"styles","3":"component---src-pages-404-js","4":"component---src-pages-index-js","5":"component---src-pages-litjen-adventskalender-index-js","6":"component---src-pages-litjen-adventskalender-luke-1-8-lc-ou-js","7":"component---src-pages-litjen-adventskalender-luke-10-nno-gy-js","8":"component---src-pages-litjen-adventskalender-luke-11-w-cue-k-js","9":"component---src-pages-litjen-adventskalender-luke-12-xw-uhc-js","10":"component---src-pages-litjen-adventskalender-luke-13-i-nns-6-js","11":"component---src-pages-litjen-adventskalender-luke-14-qx-nd-9-js","12":"component---src-pages-litjen-adventskalender-luke-15-gq-auh-js","13":"component---src-pages-litjen-adventskalender-luke-16-4-f-u-1-f-js","14":"component---src-pages-litjen-adventskalender-luke-17-nwo-7-a-js","15":"component---src-pages-litjen-adventskalender-luke-18-3-nxo-3-js","16":"component---src-pages-litjen-adventskalender-luke-19-m-rsx-a-js","17":"component---src-pages-litjen-adventskalender-luke-2-lff-lm-js","18":"component---src-pages-litjen-adventskalender-luke-20-g-gxj-c-js","19":"component---src-pages-litjen-adventskalender-luke-21-r-7-v-nd-js","20":"component---src-pages-litjen-adventskalender-luke-22-f-xjkx-js","21":"component---src-pages-litjen-adventskalender-luke-23-xm-2-bu-js","22":"component---src-pages-litjen-adventskalender-luke-24-5-mc-rz-js","23":"component---src-pages-litjen-adventskalender-luke-3-s-5-tj-m-js","24":"component---src-pages-litjen-adventskalender-luke-4-m-xvs-o-js","25":"component---src-pages-litjen-adventskalender-luke-5-k-5-w-xc-js","26":"component---src-pages-litjen-adventskalender-luke-6-jm-9-zz-js","27":"component---src-pages-litjen-adventskalender-luke-7-q-8-qv-g-js","28":"component---src-pages-litjen-adventskalender-luke-8-ne-x-at-js","29":"component---src-pages-litjen-adventskalender-luke-9-l-bq-de-js","30":"component---src-pages-velkommen-js","31":"pages-manifest"}[chunkId]||chunkId) + "." + {"0":"31cbb3720280da3d44d3","1":"31d6cfe0d16ae931b73c","3":"31d6cfe0d16ae931b73c","4":"31d6cfe0d16ae931b73c","5":"31d6cfe0d16ae931b73c","6":"31d6cfe0d16ae931b73c","7":"31d6cfe0d16ae931b73c","8":"31d6cfe0d16ae931b73c","9":"31d6cfe0d16ae931b73c","10":"31d6cfe0d16ae931b73c","11":"31d6cfe0d16ae931b73c","12":"31d6cfe0d16ae931b73c","13":"31d6cfe0d16ae931b73c","14":"31d6cfe0d16ae931b73c","15":"31d6cfe0d16ae931b73c","16":"31d6cfe0d16ae931b73c","17":"31d6cfe0d16ae931b73c","18":"31d6cfe0d16ae931b73c","19":"31d6cfe0d16ae931b73c","20":"31d6cfe0d16ae931b73c","21":"31d6cfe0d16ae931b73c","22":"31d6cfe0d16ae931b73c","23":"31d6cfe0d16ae931b73c","24":"31d6cfe0d16ae931b73c","25":"31d6cfe0d16ae931b73c","26":"31d6cfe0d16ae931b73c","27":"31d6cfe0d16ae931b73c","28":"31d6cfe0d16ae931b73c","29":"31d6cfe0d16ae931b73c","30":"31d6cfe0d16ae931b73c","31":"31d6cfe0d16ae931b73c"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
